<div class="h-full flex flex-col">
    <div class="flex-1 flex overflow-auto h-full m-3">
        <div class="flex flex-col xl:flex-row gap-4 h-full w-full max-w-7xl mx-auto">
            @if (loading) {
            <div class="flex-1 flex items-center justify-center">
                <p-skeleton width="100%" height="60%" />
            </div>
            } @else {
            <!-- Left Section - Profile Form -->
            <div class="flex flex-col gap-3 flex-1 xl:w-1/2">
                <!-- profile card  -->
                <div class="border shadow-md p-3 rounded-base flex-shrink-0 flex-1">
                    <form [formGroup]="profileForm" (ngSubmit)="onSaveChanges()" class="h-full flex flex-col gap-4">
                        <div class="flex-1 overflow-auto min-h-0 max-h-full flex flex-col gap-2"
                            [ngStyle]="{'overflow-y': phoneInput.isDropDownOpen() ? 'auto' : 'clip'}">
                            <h1 class="text-lg font-semibold">Profile</h1>
                            <div class="flex flex-col gap-4">
                                <div class="flex justify-between items-start gap-2">
                                    <div class="flex flex-col gap-2">
                                        <label for="profilePicture">Profile Picture</label>
                                        <div class="flex justify-between items-start gap-4 w-full">
                                            <!-- CASE 1: Picture exists and not marked for removal - Show picture with edit/delete overlay on hover (edit mode only) -->
                                            <div *ngIf="profileForm.value.profilePicture && !removePicture"
                                                class="relative h-[6.25rem] w-[6.25rem] rounded-full overflow-hidden border-2 border-gray-200 group">
                                                <img [src]="profileForm.value.profilePicture" alt="Profile Picture"
                                                    class="h-full w-full object-cover">

                                                <!-- Edit/Delete icons overlay - visible on hover in edit mode -->
                                                <div *ngIf="canEdit"
                                                    class="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center gap-3">
                                                    <app-button (clicked)="triggerPictureFileInput()" variant="outlined"
                                                        severity="contrast" pTooltip="Edit Picture"
                                                        [icon]="'pi pi-pencil'" />
                                                    <app-button (clicked)="removeSelectedFile()" variant="outlined"
                                                        severity="danger" pTooltip="Delete Picture"
                                                        [icon]="'pi pi-trash'" />
                                                </div>
                                            </div>

                                            <!-- CASE 2: No picture OR picture removed - Show "Add Picture" button (edit mode only) -->
                                            <div *ngIf="(removePicture || !profileForm.value.profilePicture) && canEdit"
                                                class="h-[6.25rem] w-[6.25rem] bg-slate-100 rounded-full flex items-center justify-center text-center text-sm text-gray-800 hover:cursor-pointer transform transition-transform duration-200 hover:scale-105 border-2 border-dashed border-gray-300"
                                                (click)="triggerPictureFileInput()">
                                                <div class="flex flex-col items-center gap-1">
                                                    <i class="pi pi-plus text-lg"></i>
                                                    <span class="text-xs font-medium">Add Picture</span>
                                                </div>
                                            </div>

                                            <!-- CASE 3: No picture in view mode - Show "No Picture" placeholder (non-editable/view mode) -->
                                            <div *ngIf="!profileForm.value.profilePicture && !removePicture && !canEdit"
                                                class="h-[6.25rem] w-[6.25rem] bg-slate-100 rounded-full flex items-center justify-center text-center text-sm text-gray-400 border-2 border-gray-200">
                                                <div class="flex flex-col items-center gap-1">
                                                    <i class="pi pi-user text-lg"></i>
                                                    <span class="text-xs">No Picture</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex gap-2">
                                        @if (!canEdit) {
                                        <app-button (clicked)="enterEditMode()" label="Edit Profile" variant="outlined"
                                            severity="contrast" icon="pi pi-pencil" iconPos="left" />
                                        }
                                        <!-- add deactivate account button -->
                                        @if(canDeactivate){
                                        <div class="flex items-center gap-2 border border-gray-300 rounded-base p-2 cursor-pointer hover:bg-gray-50"
                                            (click)="deactivateAccount()">
                                            <app-icon [type]="SVG.DEACTIVATE" [source]="'svg'" [size]="'sm'"
                                                [class]="'text-danger'"></app-icon>
                                            <span class="text-sm font-medium text-danger">Deactivate account</span>
                                        </div>
                                        }
                                        @if(canRevokeDeactivation){
                                        <div class="flex items-center gap-2 border border-gray-300 rounded-base p-2 cursor-pointer hover:bg-gray-50"
                                            (click)="revokeDeactivation()">
                                            <app-icon [type]="SVG.REVOKE" [source]="'svg'" [size]="'sm'"
                                                [class]="'text-success'"></app-icon>
                                            <span class="text-sm font-medium text-danger">Revoke deactivation</span>
                                        </div>
                                        }

                                    </div>

                                    <input #pictureFileInput type="file"
                                        accept="image/jpeg,image/jpg,image/png,image/gif" class="hidden"
                                        (change)="onFileSelect($event)">
                                </div>
                                <div class="flex flex-col w-full gap-2">
                                    <div class="flex flex-col">
                                        <label for="firstName">First Name <span class="text-danger">*</span></label>
                                        <input id="firstName" formControlName="firstName" [readOnly]="!canEdit"
                                            class="input-field" placeholder="John" />
                                        <div *ngIf="profileForm.controls['firstName'].errors && profileForm.controls['firstName'].touched"
                                            class="text-danger text-xs mt-1">
                                            <small *ngIf="profileForm.controls['firstName'].errors?.['required']">
                                                {{"*First Name is Required" | titlecase}}</small>
                                        </div>
                                    </div>
                                    <div class="flex flex-col">
                                        <label for="lastName">Last Name</label>
                                        <input id="lastName" formControlName="lastName" [readOnly]="!canEdit"
                                            class="input-field" placeholder="Doe" />
                                        <div *ngIf="profileForm.controls['lastName'].errors && profileForm.controls['lastName'].touched"
                                            class="text-danger text-xs mt-1">
                                            <small *ngIf="profileForm.controls['lastName'].errors?.['required']">
                                                {{"*Last Name is Required" | titlecase}}</small>
                                        </div>
                                    </div>
                                    <div class="flex flex-col">
                                        <label for="email">Email <span class="text-danger">*</span></label>
                                        <input id="email" type="email" formControlName="email" [readOnly]="!canEdit"
                                            class="input-field" placeholder="john@example.com" />
                                        <div *ngIf="profileForm.controls['email'].errors && profileForm.controls['email'].touched"
                                            class="text-danger text-xs mt-1">
                                            <small *ngIf="profileForm.controls['email'].errors?.['required']">
                                                {{"*Email is Required" | titlecase}}</small>
                                            <small *ngIf="profileForm.controls['email'].errors?.['email']">
                                                {{"*Please enter a valid email address" | titlecase}}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="flex flex-col">
                                        <label for="username">Username <span class="text-danger">*</span></label>
                                        <input id="username" formControlName="username" [readOnly]="!canEdit"
                                            class="input-field" />
                                        <div *ngIf="profileForm.controls['username'].errors && profileForm.controls['username'].touched"
                                            class="text-danger text-xs mt-1">
                                            <small *ngIf="profileForm.controls['username'].errors?.['required']">
                                                {{"*Username is Required" | titlecase}}</small>
                                        </div>
                                    </div>
                                    <div class="flex flex-col">
                                        <label for="phoneNumber">Contact</label>
                                        <app-phone-input #phoneInput [readOnly]="!canEdit"
                                            formControlName="phoneNumber" appendTo="body"></app-phone-input>
                                        <div *ngIf="profileForm.controls['phoneNumber'].errors && profileForm.controls['phoneNumber'].touched"
                                            class="text-danger text-xs mt-1">
                                            <small *ngIf="profileForm.controls['phoneNumber'].errors?.['required']">
                                                {{"*Phone number is required" | titlecase}}</small>
                                            <small
                                                *ngIf="profileForm.controls['phoneNumber'].errors?.['invalidNumber']">
                                                {{"*Please enter a valid phone number" | titlecase}}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (canEdit) {
                        <div class="flex gap-2 w-full">
                            <app-button class="flex-1" [fullWidth]="true" (clicked)="cancelChanges()" label="Cancel"
                                variant="outlined" severity="contrast" />
                            <app-button class="flex-1" [fullWidth]="true" label="Save Changes" icon="pi pi-save"
                                variant="filled" severity="primary" (clicked)="onSaveChanges()"
                                [disabled]="!profileForm.valid" />
                        </div>
                        }
                    </form>
                </div>

                <!-- security and privacy card  -->
                <div class="border shadow-md p-3 rounded-base flex-shrink-0 flex-1">
                    <div class="flex flex-col gap-4">
                        <h1 class="text-lg font-semibold">Security & Privacy</h1>
                        <div class="flex items-stretch w-full gap-4">
                            <label class="text-sm font-medium">Enable MFA Authentication</label>
                            <app-toggle [(ngModel)]="mfaEnabled" (onChange)="onMfaToggle($event)" />
                        </div>
                        @if(mfaEnabled){
                        <div class="flex items-center justify-between w-full gap-2">
                            <label class="text-sm font-medium">Primary method of MFA</label>
                            <app-select [options]="mfaOptions" [config]="mfaConfig"
                                (onChange)="handlePrimaryModeChanges($event)" [(value)]="selectedMfaMethod">
                            </app-select>
                        </div>
                        }
                        <div class="flex items-center justify-between w-full gap-2">
                            <div class="flex flex-col gap-1" tooltipPosition="top">
                                <span class="flex items-center gap-1">
                                    <label class="text-sm font-medium">Passkey</label>
                                </span>
                                <span class="text-sm text-gray-500">
                                    {{
                                    currentUser?.passkey ? "Passkey is enabled" :
                                    "Passkey not enabled"
                                    }}
                                </span>
                            </div>
                            @if(currentUser?.passkey){
                            <app-button variant="outlined" severity="contrast" label="Remove passkey"
                                (clicked)="removePasskey()" />
                            }

                            @if(!currentUser?.passkey){
                            <app-button variant="outlined" severity="contrast" label="Set up passkey"
                                (clicked)="setupPasskey()" />
                            }
                        </div>
                        <div class="flex items-center justify-between w-full gap-2">
                            <div class="flex flex-col gap-1">
                                <span class="flex items-center gap-1">
                                    <label class="text-sm font-medium">Add
                                        Authenticator</label>
                                </span>
                                <span class="text-sm text-gray-500">
                                    {{!currentUser?.mfaSecret ||
                                    currentUser?.mfaSecret === "" ?
                                    "Authenticator mode is not enabled"
                                    : "Authenticator mode is enabled"}}
                                </span>
                            </div>
                            @if(!this.currentUser?.mfaSecret || this.currentUser?.mfaSecret === ""){
                            <app-button variant="outlined" severity="contrast" label="Set up authenticator mode"
                                (clicked)="openAuthenticatorMode()" />
                            }
                            @else {
                            <app-button variant="outlined" severity="contrast" label="Remove authenticator mode"
                                (clicked)="removeAuthenticatorMode()" />
                            }
                        </div>
                        <hr>
                        <div class="flex items-center justify-between w-full gap-2">
                            <div class="flex flex-col gap-1">
                                <span class="flex items-center gap-1">
                                    <label class="text-sm font-medium">Change Password</label>
                                </span>
                            </div>
                            <app-button variant="outlined" severity="contrast" label="Change password"
                                (clicked)="openChangePassword()" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Section - Consumption Cards -->
            <div class="flex-1 xl:w-1/2 flex flex-col gap-3">
                <p-card class="border rounded-base flex-shrink-0">
                    <div class="flex-1 flex flex-col gap-2">
                        <h1 class="text-lg font-semibold">Today's consumption</h1>
                        <div class="flex gap-3">
                            <div class="flex flex-col items-center">
                                <div echarts [options]="chartOption" class="gauge-chart"></div>
                            </div>
                            <div class="flex flex-col justify-center">
                                <div><span class="font-bold">{{totalTokens}}</span><br> tokens been consumed</div>
                            </div>
                        </div>
                    </div>
                </p-card>
                <p-card class="border rounded-base flex-1 min-h-0 overflow-auto">
                    <div class="flex flex-col h-full gap-2">
                        <div class="flex justify-between items-center">
                            <h1 class="text-lg font-semibold">Recent consumption</h1>
                            <app-button label="View all" variant="outlined" severity="contrast"
                                (clicked)="navigateToConsumptionPage()" type="button" />
                        </div>
                        <div class="flex-1 overflow-auto">
                            <app-data-table [data]="consumptionData" [columns]="consumptionColumns"
                                [config]="consumptionTableConfig" tableClass="consumption-table">
                            </app-data-table>
                        </div>
                    </div>
                </p-card>
            </div>
            }
        </div>
    </div>
</div>

<app-dialog [(visible)]="changePasswordVisible" title="Change Password" [closable]="true" [showCloseButton]="true"
    (closed)="changePasswordVisible = false" class="max-w-[500px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div [formGroup]="changePasswordForm" class="flex flex-col w-full gap-4 p-4">
            <div class="form-field">
                <label for="currentPassword">Current Password</label>
                <p-password inputId="currentPassword" styleClass="w-full" inputStyleClass="w-full" [toggleMask]="true"
                    [feedback]="false" formControlName="currentPassword" />
                <div *ngIf="changePasswordForm.get('currentPassword')?.invalid && changePasswordForm.get('currentPassword')?.touched"
                    class="text-danger text-xs mt-1">
                    <div *ngIf="changePasswordForm.get('currentPassword')?.errors?.['required']">Current password is
                        required.</div>
                    <div *ngIf="changePasswordForm.get('currentPassword')?.errors?.['minlength']">Password must be at
                        least 8 characters long.</div>
                </div>
            </div>
            <div class="form-field">
                <label for="newPassword">New Password</label>
                <p-password inputId="newPassword" styleClass="w-full" inputStyleClass="w-full" [toggleMask]="true"
                    formControlName="password" />
                <div *ngIf="changePasswordForm.get('password')?.invalid && changePasswordForm.get('password')?.touched"
                    class="text-danger text-xs mt-1">
                    <div *ngIf="changePasswordForm.get('password')?.errors?.['required']">New password is required.
                    </div>
                    <div *ngIf="changePasswordForm.get('password')?.errors?.['minlength']">Password must be at least 8
                        characters long.</div>
                </div>
            </div>
            <div class="form-field">
                <label for="confirmPassword">Confirm New Password</label>
                <p-password inputId="confirmPassword" styleClass="w-full" inputStyleClass="w-full" [toggleMask]="true"
                    [feedback]="false" formControlName="confirmPassword" />
                <div *ngIf="changePasswordForm.get('confirmPassword')?.invalid && changePasswordForm.get('confirmPassword')?.touched"
                    class="text-danger text-xs mt-1">
                    <div *ngIf="changePasswordForm.get('confirmPassword')?.errors?.['required']">Confirm password is
                        required.</div>
                    <div *ngIf="changePasswordForm.get('confirmPassword')?.errors?.['minlength']">Password must be at
                        least 8 characters long.</div>
                </div>
                <div *ngIf="changePasswordForm.hasError('passwordMismatch') && changePasswordForm.get('confirmPassword')?.touched"
                    class="text-danger text-xs mt-1">
                    Passwords do not match.
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Cancel" (clicked)="cancelChangePassword()" variant="outlined" severity="contrast" />
            <app-button label="Save" variant="filled" severity="primary" (clicked)="saveChangePassword()"
                [disabled]="!changePasswordForm.valid" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="openMfaDialog" title="Setup Authenticator App" [closable]="false" [showCloseButton]="false"
    (closed)="resetMfaDialog()" class="max-w-[560px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4">
            <div class="flex flex-col items-center space-y-4">
                <div class="text-center">
                    <h3 class="text-lg font-semibold mb-2">Scan QR Code</h3>
                    <p class="text-sm text-gray-600 mb-4">
                        Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)
                    </p>
                    @if(qrCodeLoading) {
                    <div class="flex justify-center items-center h-48">
                        <i class="pi pi-spinner pi-spin text-2xl"></i>
                        <span class="ml-2">Generating QR Code...</span>
                    </div>
                    } @else if(qrCodeDataUrl) {
                    <div class="flex justify-center">
                        <img [src]="qrCodeDataUrl" alt="MFA QR Code" class="border rounded-base shadow-sm" />
                    </div>
                    } @else {
                    <div class="text-danger">Failed to generate QR code</div>
                    }
                </div>
            </div>
            <div class="w-full">
                <label for="otpToken" class="block text-sm font-medium mb-2">
                    Enter the 6-digit code from your authenticator app:
                </label>
                <input id="otpToken" type="text" [(ngModel)]="mfaCode" maxlength="6" placeholder="123456"
                    class="w-full px-3 py-2 border border-gray-300 rounded-base focus:outline-none focus:ring-2 focus:ring-orange-500 text-center text-lg tracking-widest" />
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Cancel" (clicked)="openMfaDialog = false; resetMfaDialog()" variant="outlined"
                severity="contrast" />
            <app-button variant="filled" severity="primary" (clicked)="verifyMFA()"
                [disabled]="!mfaCode || mfaCode.length !== 6 || verifyingOtp"
                [label]="verifyingOtp ? 'Verifying...' : 'Verify & Enable'" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="deactivateDialogVisible" [closable]="false" [showCloseButton]="false"
    (closed)="deactivateDialogVisible = false" class="max-w-[640px]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <hlm-dialog-header>
            <div class="flex items-center gap-3">
                <app-icon [type]="'pi pi-minus-circle'" [source]="'primeng'" [size]="'sm'"
                    [class]="'text-red-500'"></app-icon>
                <div>
                    <div class="font-bold text-lg">Are you sure you want to deactivate your account?</div>
                    <p class="text-gray-700 text-sm">
                        This action can't be undone and you will lose access to all your data and documents.
                    </p>
                </div>
            </div>
        </hlm-dialog-header>
    </ng-template>
    <ng-template #bodyTemplate>
        @if (isSuperAdmin) {
        @if (loadingOrgUserCount) {
        <div class="flex items-center justify-center p-8">
            <p-skeleton width="100%" height="3rem" />
        </div>
        } @else if (orgUserCount > 1) {
        <div class="flex items-start gap-3 p-4 m-4 bg-amber-50 border border-amber-200 rounded-lg">
            <app-icon [type]="'triangle-alert'" [source]="'lucide'" [size]="'sm'"
                [class]="'text-amber-500 mt-0.5 flex-shrink-0'"></app-icon>
            <p class="text-sm text-amber-800">
                You are the only Account Owner. Transfer ownership to another user before leaving.
            </p>
        </div>
        }
        } @else {

        @if (orgUserCount == 1) {
        <div class="flex items-start gap-3 p-4 m-4 bg-red-50 border border-red-200 rounded-lg">
            <app-icon [type]="'triangle-alert'" [source]="'lucide'" [size]="'sm'"
                [class]="'text-red-500 mt-0.5 flex-shrink-0'"></app-icon>
            <p class="text-sm text-red-800">
                You are the only user in this organization. Deleting will permanently remove the organization and all
                its data.
            </p>
        </div>
        }

        <div class="flex flex-col gap-4 p-4">
            <div class="flex flex-col gap-2">
                <label for="deactivateConfirmation" class="text-sm font-medium text-gray-700">
                    Please type deactivate to confirm<span class="text-red-500">*</span>
                </label>
                <input id="deactivateConfirmation" pInputText [(ngModel)]="deactivateConfirmation"
                    placeholder="Type here" class="w-full border border-gray-300 rounded p-2" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2">
                <label for="deactivateReason" class="text-sm font-medium text-gray-700">
                    Reason to deactivate? (Optional)
                </label>
                <textarea id="deactivateReason" pInputTextarea [(ngModel)]="deactivateReason" placeholder="Type here"
                    [rows]="4" class="w-full border border-gray-300 rounded p-2 resize-none"></textarea>
            </div>
        </div>
        }
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Cancel" (clicked)="cancelDeactivate()" variant="outlined" severity="contrast" />
            @if (!isSuperAdmin) {
            <app-button label="Yes, deactivate" (clicked)="confirmDeactivate()" variant="filled" severity="danger"
                [disabled]="(deactivateConfirmation || '').toLowerCase() !== 'deactivate' || deactivatingAccount"
                [loading]="deactivatingAccount" />
            } @else if (!loadingOrgUserCount && orgUserCount
            <= 1) { <app-button label="Delete Organization" (clicked)="confirmDeleteOrganization()" variant="filled"
                severity="danger" [loading]="deletingOrganization" />
            }
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="revokeDeactivationDialogVisible" [closable]="false" [showCloseButton]="false"
    (closed)="revokeDeactivationDialogVisible = false" class="max-w-[480px]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <hlm-dialog-header>
            <div class="flex items-center gap-3">
                <app-icon [type]="SVG.REVOKE" [source]="'svg'" [size]="'sm'" [class]="'text-white'"></app-icon>
                <div class="font-bold text-lg">Revoke Deactivation Request?</div>
            </div>
        </hlm-dialog-header>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="p-4">
            <p class="text-gray-700">
                Are you sure you want to revoke your deactivation request? Your account will remain active.
            </p>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Cancel" (clicked)="cancelRevokeDeactivation()" variant="outlined" severity="contrast" />
            <app-button label="Yes, revoke" (clicked)="confirmRevokeDeactivation()" variant="filled" severity="danger"
                [disabled]="revokingDeactivation" [loading]="revokingDeactivation" />
        </div>
    </ng-template>
</app-dialog>

<!-- Transfer Billing Admin Dialog -->
<app-dialog [(visible)]="transferBillingAdminDialogVisible" title="Transfer Billing Admin"
    description="You are the billing admin. Please transfer this role to another user before deactivating your account."
    class="max-w-lg" [closable]="false" [showCloseButton]="false">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-1">
            <input type="text" [(ngModel)]="billingAdminTransferSearchQuery" (input)="onBillingAdminTransferSearch()"
                placeholder="Search by name or email"
                class="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:border-orange-500" />
            <div class="flex flex-col gap-1 max-h-64 overflow-y-auto">
                @for(user of billingAdminTransferFilteredUsers; track user._id){
                <div class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-50 border"
                    [class.border-orange-500]="selectedBillingAdminTransferUser?._id === user._id"
                    [class.bg-orange-50]="selectedBillingAdminTransferUser?._id === user._id"
                    [class.border-transparent]="selectedBillingAdminTransferUser?._id !== user._id"
                    (click)="selectedBillingAdminTransferUser = user">
                    <img [src]="user | userAvatar" class="rounded-full w-8 h-8 object-cover" alt="" />
                    <div class="flex flex-col flex-1 min-w-0">
                        <span class="text-sm font-medium truncate">{{ user | fullName }}</span>
                        <span class="text-xs text-gray-500 truncate">{{ user.email }}</span>
                    </div>
                    @if(selectedBillingAdminTransferUser?._id === user._id){
                    <app-icon type="check" source="lucide" class="text-orange-500" />
                    }
                </div>
                } @empty {
                <div class="text-sm text-gray-500 text-center py-4">No users found</div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel"
                (clicked)="cancelBillingAdminTransfer()" />
            <app-button variant="filled" severity="primary" label="Transfer & Continue"
                [disabled]="!selectedBillingAdminTransferUser || isTransferringBillingAdmin"
                (clicked)="confirmBillingAdminTransfer()" />
        </div>
    </ng-template>
</app-dialog>

<!-- Transfer Ownership Dialog -->
<app-transfer-ownership-dialog [(visible)]="transferOwnershipDialogVisible" [userCount]="1"
    [isDefaultTransferDisabled]="isDefaultTransferDisabled" [transferFunction]="getTransferFunction()"
    (transferCompleted)="onTransferCompleted($event)" (transferConfirmed)="onTransferOwnershipConfirmed($event)">
</app-transfer-ownership-dialog>